import { IOtherCostsDto } from '../../../refund-calculator-types';
import CalculatorLineItem from '../calculator-line-item/calculator-line-item';

interface ICalculatorCategoryProps {
    data: IOtherCostsDto;
    title: React.ReactNode;
}

const CalculatorOtherCostCategory: React.FC<ICalculatorCategoryProps> = ({ data, title = "" }) => {
    return (
        <div className="refund-calculator__category">
            {title}
            <div className="refund-calculator__category-items">
                {data?.switch_to_exchange ? (
                    <CalculatorLineItem
                        description={`Switch to Exchange: ${data.switch_to_exchange.percentage}%`}
                        price={data.switch_to_exchange.amount}
                        tax={data.switch_to_exchange.tax}
                        taxRate={data.switch_to_exchange.tax_rate || 0}
                    />
                ) : null}
                {data?.original_order_shipping_cost ? (
                    <CalculatorLineItem
                        description="Original order shipping cost"
                        price={data.original_order_shipping_cost.amount}
                        tax={data.original_order_shipping_cost.tax}
                        taxRate={data.original_order_shipping_cost.tax_rate || 0}
                    />
                ) : null}
                {data?.checkout_threshold_adjustment ? (
                    <CalculatorLineItem
                        description="Checkout threshold adjustment"
                        price={data.checkout_threshold_adjustment.amount}
                        tax={data.checkout_threshold_adjustment.tax}
                        taxRate={data.checkout_threshold_adjustment.tax_rate || 0}
                    />
                ) : null}
            </div>
        </div>
    );
};

export default CalculatorOtherCostCategory;
